import React, { Component } from "react";
import { Button, Modal } from "antd";
import PropTypes from "prop-types";
import "antd/dist/antd.css";

class MessagePushList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#0050B3",
  };
  // 静态类型分析
  static propTypes = {
    content: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    senderName: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    sendTime: PropTypes.string.isRequired,
    force: PropTypes.string,
    pictureUrl: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.props.getWithdrawGroupList();
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  render() {
    let status = this.props.status;
    let operate;
    if (status === 0) {
      operate = (
        <div>
          <Button type="danger" size="small" onClick={this.showModal}>
            撤回
          </Button>
        </div>
      );
    } else if (status === "-1") {
      operate = "";
    } else {
      operate = "";
    }
    return (
      <div style={{ width: "100%" }}>
        <table
          style={{
            border: "1px solid #666",
            textAlign: "center",
          }}
        >
          <tbody>
            <tr
              style={{
                border: "1px solid #e6e6e6",
                height: "35px",
                lineHeight: "35px",
              }}
            >
              <td

              >
                <div style={{
                  width: "169px",
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineClamp: 1,
                  whiteSpace: "nowrap"
                }}>{this.props.title}</div>
              </td>
              <td
              >
                <div style={{
                  width: "455px",
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineClamp: 1,
                  whiteSpace: "nowrap"
                }}>{this.props.content}</div>
              </td>
              <td

              >
                <div style={{
                  width: "133px",
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineClamp: 1,
                  whiteSpace: "nowrap"
                }}>{this.props.groupName}</div>
              </td>
              <td
                style={{
                  width: "124px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div style={{ width: "50px", height: "28px" }}>
                  <img style={{ width: "50px", height: "28px", objectFit: "cover", maxHeight: "100%" }} src={this.props.pictureUrl} alt="" />
                </div>
              </td>
              <td
                style={{
                  width: "133px",
                }}
              >
                <div>{this.props.senderName}</div>
              </td>
              <td
                style={{
                  width: "125px",
                }}
              >
                <div>
                  {this.props.status === 0
                    ? "已发布"
                    : this.props.status === -1
                      ? "已撤回"
                      : null}
                </div>
              </td>
              <td
                style={{
                  width: "187px",
                }}
              >
                <div>{this.props.sendTime}</div>
              </td>
              <td
                style={{
                  width: "159px",
                }}
              >
                <div>{this.props.force === false ? "否" : "是"}</div>
              </td>
              <td style={{ width: "177px" }}>
                <div>{operate}</div>
              </td>
              <Modal
                centered
                title="信息"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                width="400px"
              >
                是否撤回此消息？
              </Modal>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  editItem = () => {
    this.refs.indexLinkItem.showModal();
  };
}

export default MessagePushList;
